import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { SolicitudCpeService } from './datosbasicos/cpe.service';
import { ProductosCpeService } from './productos/productosCpe.service';
import { DocumentosCpeService } from './documentos/documentosCpe.service';
import { CertificacionService } from './certificacion/certificacion.service';
import { EnvioCpeService } from './envio/envioCpe.service';
import { CoreModule } from '../../core/core.module';
import { AppModuleGlobalShared } from '../../../app.module.global';
import { CpeEditComponent } from './datosbasicos/cpe-edit.component';
import { ProductosCpeListComponent } from './productos/productosCpe-list.component';
import { DocumentosCpeListComponent } from './documentos/documentosCpe-list.component';
import { CertificacionEditComponent } from './certificacion/certificacion-edit.component';
import { EnvioCpeEditComponent } from './envio/envioCpe-edit.component';
import { TipoSolicitudCpeListComponent } from './tipossolicitudes/tiposolicitudCpe-list.component';
import { ProductoCpeEditComponent } from './productos/productosCpe-edit.component';
import { DocumentosCpeEditComponent } from './documentos/documentosCpe-edit.component';
import { AnulacionCpeEditComponent } from './anulacion/anulacionCpe-edit.component';
import { AnulacionCpeService } from './anulacion/anulacionCpe.service';
import { LugarProduccionComponent } from './lugarproduccion/lugarproduccion.component';
import { LugarProduccionService } from './lugarproduccion/lugarproduccion.service';
import { CpeRoutingModule } from './cpe-routing.module';

@NgModule({
    declarations: [
        TipoSolicitudCpeListComponent,
        CpeEditComponent,
        ProductosCpeListComponent,
        ProductoCpeEditComponent,
        LugarProduccionComponent,
        DocumentosCpeListComponent,
        DocumentosCpeEditComponent,
        AnulacionCpeEditComponent,
        EnvioCpeEditComponent,
        CertificacionEditComponent,
    ],
    imports: [CoreModule, AppModuleGlobalShared, CommonModule, FormsModule, ReactiveFormsModule, CpeRoutingModule],
    exports: [],
    providers: [
        SolicitudCpeService,
        ProductosCpeService,
        DocumentosCpeService,
        LugarProduccionService,
        CertificacionService,
        AnulacionCpeService,
        EnvioCpeService,
    ],
})
export class CpeModule {}
